<template>
  <moe-page>
    <moe-top></moe-top>
    <div class="coupon_box flex Flexjustify">
      <div class="coupon_content">
        <div class="flex Flexalign FlexBetween content_top">
          <div>公告</div>
          <div class="flex Flexalign">
            <el-image class="back_icon" :src="iconPath('back_icon.png')"></el-image>
            <div class="mar_left_10 text_active cursor_pointer" @click="back">返回</div>
          </div>
        </div>
        <div v-if="listTotal">
          <div class="notice_list mar_top_10">
            <div class="notice_one flex FlexBetween Flexalign cursor_pointer" v-for="(item, index) in noticeList" :key="index" @click="goNoticeDetail(item)">
              <div class="notice_title">{{ item.noticeTitle }}</div>
              <div class="notice_time">{{ item.createTime?.split(" ")[0] }}</div>
            </div>
          </div>
          <div class="pagination_box mar_top_10 flex FlexjustifyEnd" v-if="listTotal>noticeListQuery.pageSize">
            <el-pagination background layout="prev, pager, next" :total="listTotal"
              @current-change="handleCurrentChange" />
          </div>
        </div>
        <div v-else>
          <moe-empty url="moe_empty_bg_img.png" emptyText="暂无公告"></moe-empty>
        </div>
      </div>
    </div>
  </moe-page>
</template>

<script>
export default {
  name: "GjkcH5Notice",

  data() {
    return {
      noticeList: [],
      noticeListQuery: {
        courseId: '',
        page: 1,
        pageSize: 10
      },
      listTotal: ''
    };
  },

  mounted() {
    this.getNoticeList();
  },

  methods: {
    getNoticeList() {
      this.$Api.course.getCourseNoticeList(this.noticeListQuery).then(res => {
        this.noticeList = res.data.data.list;
        this.listTotal = res.data.data.total ? Number(res.data.data.total) : 0;
      }).catch(() => { })
    },
    handleCurrentChange(value) {
      this.listQuery.page = value;
      this.getNoticeList();
    },
    goNoticeDetail(info){
      this.href("/noticeDetail",{noticeId:info.noticeId});
    }
  },
};
</script>

<style lang="scss" scoped>
.coupon_box {
  width: 100%;
  min-height: calc(100vh - $pageTopHeight);
  background: #f3f3f3;

  .coupon_content {
    margin-top: 20px;
    box-sizing: border-box;
    width: $pageMainWidth;
    height: 600px;
    background: #ffffff;
    border-radius: 10px;
    padding: 20px;

    .content_top {
      font-size: 18px;
      color: #111111;
      border-bottom: 1px solid rgba(20, 20, 20, 0.1);
      padding-bottom: 15px;

      .back_icon {
        width: 24px;
        height: 24px;
      }
    }

    .notice_list {
      .notice_one {
        line-height: 41px;

        .notice_title {
          color: #333333;
          // font-weight: 600;
        }

        .notice_time {
          color: #999999;
        }
      }
    }
  }
}
</style>